module.exports = __webpack_public_path__ + "static/media/icon-dollar-sign.cbeab270.svg";